import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import your generated JSON files
import enTranslation from './locales/en/en.json';
import esTranslation from './locales/es/es.json';
import frTranslation from './locales/fr/fr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      es: { translation: esTranslation },
      fr: { translation: frTranslation },
    },
    fallbackLng: 'en',
    // Set to true only in development to see missing key warnings in console
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // React already safes from XSS
    },
    
    // Ensure it looks for the language code without the region (e.g., 'en' instead of 'en-US')
    // unless you specifically need regional translations.
    load: 'languageOnly',
    
    react: {
      useSuspense: false, // Prevents white-screen flickers during load
    },
  });

export default i18n;